import { HttpClient } from '@angular/common/http';
import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop'
import { defer, interval, of, Subject, Subscription, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { FormatPipe } from '@app/pipes/format.pipe';

@Injectable({
  providedIn: 'root'
})
export class Settings {

  private apiURL: string = environment.apiURL
  private settingEndpoint: string = environment.settings
  private http = inject(HttpClient)
  private router = inject(Router)
  private formatPipe = inject(FormatPipe)

  private cancel$ = new Subject<void>();
  private autoRefresh?: Subscription;

  settings = signal<any>({})
  categorySetting = signal<string>("")

  settingsRessource = rxResource({
    request: () => ({
      category: this.categorySetting()
    }),
    loader: ({ request }) =>
      defer(() => {
        if (request.category.trim() === '') return of(null);
        return this.http.get<any>(
          `${this.apiURL + this.formatPipe.transform(this.settingEndpoint, {'category': request.category})}`
        );
      })
  });

  startAutoRefresh() {
    if (this.autoRefresh && !this.autoRefresh.closed) return;

    this.cancel$ = new Subject<void>();

    this.autoRefresh = interval(this.settings()['GLOBAL'].kiosk_auto_refresh as number)
      .pipe(takeUntil(this.cancel$))
      .subscribe(() => {
        if(this.categorySetting() === 'KIOSK')
          this.settingsRessource.reload()
        else
          this.categorySetting.set('KIOSK')
      });
  }


  stopAutoRefresh() {
    // Signal cancellation to all streams using takeUntil(this.cancel$)
    this.cancel$.next();

    // Explicitly unsubscribe the interval
    if (this.autoRefresh && !this.autoRefresh.closed) {
      this.autoRefresh.unsubscribe();
    }
  }

  isLoadingSettings = computed (() => this.settingsRessource.isLoading())
  // settingsValue = computed (() => this.settingsRessource.value())

  eff = effect( () => {
    if (!this.settingsRessource.isLoading()){
      if(this.categorySetting() === 'TV') {
        this.settings.update( settings => {
          return {
            allow_device: settings.GLOBAL.kiosk_allow_device,
            ...this.settingsRessource.value().GLOBAL
          }
        })
      } else if(this.categorySetting() === 'KIOSK'){
          this.settings.set(this.settingsRessource.value())
          this.startAutoRefresh()
      } else if (this.categorySetting() === 'NOTIFICATIONS'){
        this.settings.update( prev => {
          prev.GLOBAL = {...prev.GLOBAL, notifications_all_text_enabled: this.settingsRessource.value().GLOBAL.notifications_all_text_enabled}
          return prev
        })
      }
    }
    
    if (this.settingsRessource.error() !== undefined) {
      this.router.navigate([`/information/`, 'server'], {queryParamsHandling: 'merge'})
    }
  })


}
